import React, { Component } from "react";
import {Link} from "react-router-dom";
import Select from "react-select";

import './Product.scss';
import MyContext from '../MyContext.jsx';

class Product extends Component {
  constructor(props) {
    super(props);
    this.categorySelect = React.createRef();
    this.brandSelect = React.createRef();
    this.productSelect = React.createRef();
    this.state = {
      product_name : '',
      specifications : '',
      categories : [],
      category : {},
      brands : [],
      brand : {},
      product : {},
      products : [],
      product_type : 'NEW',
      is_active : "Y",
      selling_price:  '',
      dealer_price :  '',
      image : '',
      file : '',
      inf_image : '',
    }
    this.formChange = this.formChange.bind(this);
  }

  componentDidMount(){   
    var obj_this = this;
    const url = `${process.env.REACT_APP_SSS}/api/getMarketingProductDetails`;
    this.context.loading(1);
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid
      },
      type : "POST"
    }).done(function(return_data){
      // console.log(return_data);
      // return;
      if(return_data.status == "success"){
        obj_this.setState({
          categories : return_data.categories,
          brands : return_data.mi_brands,
          products : return_data.products,
        });
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/dashboard");
      }
    }).fail(function(){
      alert("Network error");
      obj_this.context.loading(0);
      obj_this.props.history.replace("/");
    });

  }

  formChange(e){
    this.setState({
      [e.target.name] : e.target.value
    });
  }

  productTypeChange(e){
    // console.log(option);
    this.setState({
      product_type : e.target.value
    }); 
  }

  categoryChange(option){
    this.setState({
      category : option
    });
  }

  brandChange(option){
    this.setState({
      brand : option
    });
  }

  productChange(option){
    this.setState({
      product : option
    });
  }

  isActiveChange(e) {
    if(this.state.is_active == "Y"){
      this.setState({is_active : "N"});
    }else{
      this.setState({is_active : "Y"});
    }
  }
  uploadImage = (e) => {
    if (e.target.files && e.target.files[0]) {
      this.setState({
        file: URL.createObjectURL(e.target.files[0])
      });
    }

    this.setState({
      image: e.target.files[0]
    })
    var n = document.getElementsByClassName('inf_img');
    var n1 = document.getElementsByClassName('close');

    $(n).css({
      'display': 'inline-block'
    });

    $(n1).css({
      'display': 'inline-block'
    });
  }

  getComponent(e) {
      var n = document.getElementsByClassName('inf_img');
      $(e.target).css({
        'display': 'none'
      });
      $(n).css({
        'display': 'none'
      });
      this.setState({
        image: '',
        file: ''
      })
  }

  formSubmit(e){
    e.preventDefault();
    console.log(this.state);
    var product_details = this.state;
    if(!product_details.category.value){
       this.categorySelect.current.focus();
      return;
    }
    if(!product_details.brand.value){
       this.brandSelect.current.focus();
      return;
    }
    if(!product_details.product.value){
       this.productSelect.current.focus();
      return;
    }

    // delete product_details.categories;
    // delete product_details.products;
    // delete product_details.brands;
    var fd = new FormData(document.querySelector('form'));

    fd.append('sid',this.context.user_details.sid);
    fd.append('image', this.state.image)
    fd.append("product_name", this.state.product_name);
    fd.append("specifications", this.state.specifications);
    fd.append("category", this.state.category['value']);
    fd.append("brand", this.state.brand['value']);
    fd.append("product", this.state.product['value']);
    fd.append("product_type", this.state.product_type);
    fd.append("is_active", this.state.is_active);
    fd.append("selling_price", this.state.selling_price);
    fd.append("dealer_price", this.state.dealer_price);
    fd.append("product_type", this.state.product_type);


    const url = `${process.env.REACT_APP_SSS}/api/saveMarketingProductDetails`;
    this.context.loading(1);
    var obj_this = this;
    $.ajax({
      url : url,
      data :  fd,
      type : "POST",
      processData: false,
      contentType: false
    }).done(function(return_data){
      // console.log(return_data);
      // return;
      if(return_data.status == "already exist"){
        alert("Product already exist.");
        obj_this.setState({product_name : ''});
        obj_this.context.loading(0);
      }else if(return_data.status == "success"){
        alert("Product inserted.");
        obj_this.context.loading(0);
        obj_this.props.history.replace('/dashboard');
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/dashboard");
      }
    }).fail(function(){
      alert("Network error");
      obj_this.context.loading(0);
      obj_this.props.history.replace("/dashboard");
    });
  }


  render(){
  return (
    <MyContext.Consumer>
      {context => (
        <div className="new_marketing_product_container">
          <div className="page_header">
            
            <div className="page_title"><i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{marginRight: '15px', cursor: 'pointer'}}></i> New Product</div>
          </div> 
          <form className="enquiry_form"
            onSubmit={e => this.formSubmit(e)}
          >
            <div className="product_details_container blocks">
              <div className="input_label">Name of the Product</div>
              <input className="name input custom_input"
                type="text"
                name="product_name"
                value={this.state.product_name}
                onChange={this.formChange}
                required
                autoComplete="off"
              />
              <div className="input_label">Specifications</div>
              <input className="name input custom_input"
                type="text"
                name="specifications"
                value={this.state.specifications}
                onChange={this.formChange}
                required
                autoComplete="off"
              />
              <div className="input_label">Category</div>
              <Select 
                options={this.state.categories}  
                value ={this.state.category}
                className="category" 
                ref={this.categorySelect}
                onChange={e => this.categoryChange(e)}
                required
              />  
              <div className="input_label">Brand</div>
              <Select 
                options={this.state.brands}  
                value ={this.state.brand}
                className="brand" 
                ref={this.brandSelect}
                onChange={e => this.brandChange(e)}
                required
              />     
              <div className="input_radio_container">
                <span>Type of Product : </span>
                <div className="lead_type_radio_buttons">
                  <div className="label_radio_container">
                    <input type="radio" 
                      name="product_type" 
                      value="NEW"  
                      checked={this.state.product_type == 'NEW'} 
                      onChange={e => this.productTypeChange(e)}
                    />
                    <div>NEW</div>
                  </div>
                  <div className="label_radio_container">
                    <input type="radio" 
                      name="product_type" 
                      value="EXISTING"
                      checked={this.state.product_type == 'EXISTING'} 
                      onChange={e => this.productTypeChange(e)}
                    />
                    <div>EXISTING</div>
                  </div>
                </div>
              </div>
              <div>
                <div>
                  <div className="input_label">Selling Price</div>
                  <input className="unit_price input custom_input"
                    type="number"
                    name="selling_price"
                    min="0"
                    step="0.01"
                    autoComplete="off"
                    onChange={this.formChange}
                    required
                  />
                </div>
                <div>
                  <div className="input_label">Dealer Price</div>
                  <input className="unit_price input custom_input"
                    type="number"
                    name="dealer_price"
                    min="0"
                    step="0.01"
                    autoComplete="off"
                    onChange={this.formChange}
                    required
                  />
               </div>
              </div>
             
              <div className="input_label">Similar Company Product</div>
              <Select 
                options={this.state.products}  
                value ={this.state.product}
                className="product" 
                ref={this.productSelect}
                onChange={e => this.productChange(e)}
                required
              />    
              <div className="checkbox_label_container">
                <input type="checkbox" 
                  name="is_active" 
                  value=''  
                  onChange={(e) => this.isActiveChange(e)}
                  checked={this.state.is_active == "Y"}
                /> 
                <div className="checkbox_label">Is Active</div>
              </div>
              <div>
                <span className="form-group multi-preview" style={{marginTop: '10px', display: this.state.file ? "block" : "none" }}>
                  <span className="thumbnail">
                    <img src={this.state.file} className="inf_img" />
                    <a>  <i className="close far fa-times-circle" onClick={(e) => this.getComponent(e)} > </i></a>
                  </span>
                </span>
                <div className="input_label">Upload Photo</div>
                <input className="file_upload"
                  type="file"
                  name="image"
                  id="files"
                  onChange={this.uploadImage}
                  autoComplete="off"
                  disabled={this.state.image||this.state.inf_image}

                />
                
              </div>
   
            </div>

            <button type="submit" className="submit_button"><i className="far fa-save"></i> Save</button>
          </form>           
        </div>
      )}
    </MyContext.Consumer>
  )}
}

export default Product;
Product.contextType = MyContext;
